import { call, take, put, fork, all, select } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { cookies, getChannelResourceCode } from 'src/utils';
import { fetchJson } from 'src/utils/fetch';
import { ServiceActionTypes } from './type';
// import format from 'src/utils/format';

function* upload_file() {
  while (true) {
    const action = yield take(ServiceActionTypes.UPLOAD_FILE);
    try {
      const { formData, attachmentType = '', cardNo = '' } = action;
      const res = yield call(fetchJson, {
        url: '/api/api/v1/attchment/upload',
        type: 'UPLOAD',
        isloading: true,
        action,
        data: formData,
      });
      if (res && res.code === '0') {
        const { result = [] } = res;
        yield put({
          type: ServiceActionTypes.UPLOAD_FILE_SUCCESS,
          cardNo,
          data: {
            attachmentType,
            ...result[0]
          }
        });
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* submit_service() {
  while (true) {
    const action = yield take(ServiceActionTypes.SUBMIT_SERVICE);
    try {
      const { cardNo = '', onSuccess } = action;
      const { service: { serviceCard = {}, userRealAuthInfo = {}, selectPolicy = {} } } = yield select();
      const serviceCardInfo = serviceCard[cardNo];
      const param: any = {
        ...serviceCardInfo,
        isPatientTrigger: 'N',
        patientId: serviceCardInfo.patientId || userRealAuthInfo.id,
      };
      if (serviceCardInfo.cardNo !== cardNo) {
        param.isPatientTrigger = 'Y';
        param.cardType = serviceCardInfo.vasCode;
        param.cardName = serviceCardInfo.serviceName;
        param.policyNo = selectPolicy.policyNo;
        param.policyExpiryDate = selectPolicy.policyExpiryDate;
        param.packageCode = selectPolicy.Productpolicy?.packageCode;
        param.packageName = selectPolicy.Productpolicy?.packageName;
      }
      delete param.materialOption;

      console.log(JSON.stringify({
        channelResourceCode: getChannelResourceCode(),
        ...param
      }));
      const res = yield call(fetchJson, {
        url: '/api/api/v1/patient/medical/service/package/use',
        type: 'POST',
        isloading: true,
        action,
        data: {
          channelResourceCode: getChannelResourceCode(),
          ...param,
        }
      });
      if (res && res.code === '0') {
        typeof onSuccess === 'function' && onSuccess();
        // yield put({ type: ServiceActionTypes.CLEAR_SERVICE, cardNo });
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

function* get_cardNo() {
  while (true) {
    const action = yield take(ServiceActionTypes.GET_CARDNO);
    try {
      const { cardNo = '', onSuccess } = action;
      const { service: { serviceCard = {} } } = yield select();
      const serviceCardInfo = serviceCard[cardNo];
      if (serviceCardInfo.cardNo) {
        typeof onSuccess === 'function' && onSuccess();
      } else {
        const res = yield call(fetchJson, {
          url: '/api/api/v1/patient/bizno/getByType',
          type: 'POST',
          isloading: false,
          action,
          data: {
            bizNoType: "MEDICAL_SERVICE_CARD_NO",
            params: {
              sequenceNo: "1",
              productCode: "channel"
            }
          }
        });
        if (res && res.code === '0') {
          yield put({
            type: ServiceActionTypes.EDIT_SERVICE,
            cardNo,
            key: "cardNo",
            value: res.result
          });
          typeof onSuccess === 'function' && onSuccess();
          // yield put({ type: ServiceActionTypes.CLEAR_SERVICE, cardNo });
        }
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}

// 获取用户实名信息
function* fetch_userRealAuthInfo() {
  while (true) {
    const action = yield take(ServiceActionTypes.FETCH_USER_REALAUTH_INFO);
    try {
      const { onSuccess } = action;
      const { service: { userRealAuthInfo = {} } } = yield select();

      if (userRealAuthInfo.userId && userRealAuthInfo.userId == cookies.get(`za_userId`)) {
        typeof onSuccess === 'function' && onSuccess(userRealAuthInfo);
      } else {
        const res = yield call(fetchJson, {
          type: "POST",
          url: "/api/api/v1/patient/patient/list",
          data: {
            patientRelation: 1,
          },
          isloading: true,
        });
        const { code = '0', result = [] } = res;
        if (code === '0') {
          yield put({ type: ServiceActionTypes.FETCH_USER_REALAUTH_INFO_SUCCESS, data: result[0] });
          typeof onSuccess === 'function' && onSuccess(result[0]);
        }
      }
    } catch (error) {
      StaticToast.error('网络异常，请稍后重试');
    }
  }
}


export default function* root() {
  yield all([
    // fork(cancel_inquiry),
    fork(upload_file),
    fork(submit_service),
    fork(fetch_userRealAuthInfo),
    fork(get_cardNo),
  ])
}